module.exports = __webpack_public_path__ + "media/images/official/voice_shindo-9840ebf8cc06f695e3d997fff5dc7af3.png";